export default __webpack_public_path__ + "static/media/coupon_sent.ec7955e0.png";